<template>
   <a-modal
      class="back_bill_model"
      title="退回账单"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
     <a-textarea
      v-model="remark"
      style="width:100%"
      placeholder="请写下您的异议,工作人员将尽快与你联系"
      :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </a-modal>
</template>

<script>
import {backBill}  from '@/api/bill'

  export default {
    name:'BackBillDialog',
    data(){
      return {
        visible:false,
        confirmLoading:false,
        remark:'',
        rules:{},
        row:{}
      }
    },
    methods:{
      show(row){
        this.row = row;
        this.visible = true
      },
      async handleOk(){
        if(!this.remark){
          this.$message.warning('退回原因不能为空!')
            return
        }
        const {id,billCode} = this.row;
        const params = {
          remark:this.remark,
          billId:id,
          billCode
        }
        await backBill(params)
        this.$message.success('退回成功!')
        this.$emit('refresh')
        this.handleCancel()
      },
      handleCancel(){
        this.reason = '';
        this.visible = false
      }
    }
  }
</script>

<style lang="less">
.back_bill_model{
.ant-modal{
  top: calc(50% - 125px);
}

}
</style>